// extracted by mini-css-extract-plugin
export default {"bloc-counter":"NJl49jc4T2ijpDzmwGVt"};